export default
{
    title: null,
    legend: {
        enabled: false,
        layout: 'horizontal', align:'center', verticalAlign: 'bottom',
    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'column',
        zoomType: 'x',
        animation: false,
        height: '400px',
        time: {
            useUTC: true
        }
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
        },

        gridLineWidth: 1,
        gridLineColor: 'rgba(200,200,200,0.3)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',
        tickInterval: 24 * 60 * 60 * 1000,
        minorGridLineColor: 'rgba(8,8,8,0.3)',
        labels: {
            rotation: 90,
            y:15,
        },

        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
    },
    yAxis: [{
        title: {
            text: 'Odchýlka od normálu [%]'
        },
        plotLines: [{
            color: '#000000',
            width: 2,
            value: 0
        }],

        minorTickInterval: 10,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(200,200,200,0.1)',
        gridLineColor: 'rgba(200,200,200,0.2)',

        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickInterval: 1,
        tickColor: '#000',
        plotBands:[{color: '#F8CCCC', from:-200, to:0  }]
    }, {
        linkedTo:0,
        opposite: true,
        title: {
            text: false
        },
        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickColor: '#000',
        // min: 250


    }],
    plotOptions: {
        column: {
            animation: false,
            color:'#4A7EBB',
            negativeColor:'#DC1616',
            treshold:0,
            grouping: false,
            groupPadding:0,
            pointPadding:0.1,
            // maxPointWidth:50,
            centerInCategory:true,
            borderWidth: 0,
            marker: {
                enabled: true,
                states: {
                    hover: {
                        enabled: true,
                        lineWidthPlus: 2
                    }
                }
            },
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }
        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },
        }
    },
    tooltip: {
        headerFormat: '<span style=\"font-size:10px\">{point.key}</span><table class=\"noborder\">',
        pointFormat: '<tr><td style=\"color:{series.color};padding:0;background:none;font-weight:bold;\">{series.name}: </td>' +
            '<td style=\"padding:0;background:none;color:#000\">&nbsp;<b>{point.y:.0f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        followPointer: false,
        xDateFormat: '%d.%m.%Y'

    },


    series: [
        {id:'m3', name:'Odchýlka od normálu [%]', color:'#0015FF', lineWidth:1, data:[]},
    ]

}
